import { Component, OnInit, Input } from '@angular/core';
import { ConversionConfiguration } from 'src/app/model/conversion-configuration';
import { ConversionConfigurationService } from 'src/oldApp/services/conversion-configuration.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatalogModel } from 'src/app/model/other-catalogs-models';

@Component({
  selector: 'app-modal-conversion-configuration',
  templateUrl: './modal-conversion-configuration.component.html',
  styleUrls: ['./modal-conversion-configuration.component.css']
})
export class ModalConversionConfigurationComponent implements OnInit {

  @Input() conversionConfig:ConversionConfiguration;
  @Input() page:string;
  @Input() mode:string;
  @Input() listConversionConfig:ConversionConfiguration[]=[];

  // estado pagina
  public valid:boolean=false;
  public viewStatus:number=1;
  public formIsLocked:boolean=false;
  public details:string=null;
  public title:string=null;
  public confirmTitle:string='<i class="icon-info-circled"></i>&nbsp;&nbsp;Ha ingresado la siguiente información. Está seguro de guardar?';

  // catalogos
  public conversionIntervalsCatalog:CatalogModel[]=[];
  public selectedConversionIntervalsDD:string[]=[];
  public selectedConversionIntervals:any[]=[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  constructor(
    private conversionConfigurationService:ConversionConfigurationService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
    console.log(">>> this.conversionConfig= ", this.conversionConfig);
    if(this.mode === "edit" || this.mode === "detail" && this.conversionConfig.conversionId != null && this.conversionConfig.conversionId > 0) {
      this.getCatalogs(this.conversionConfig.conversionId);
    }else{
      if(this.mode==="create") this.getCatalogs(0);
    }
    if(this.mode==='create') this.title = '<i class="icon-plus"></i>&nbsp;&nbsp;Agregar Intervalo de Conversión';
    if(this.mode==='edit') this.title = '<i class="icon-pencil"></i>&nbsp;&nbsp;Editar Intervalo de Conversión';
    if(this.mode==='detail') {
      this.title = '<i class="icon-eye"></i>&nbsp;&nbsp;Detalle Intervalo de Conversión';
      this.formIsLocked=true;
    }
    if(this.mode==='delete') {
      this.confirmTitle = '<i class="icon-attention"></i>&nbsp;&nbsp;Se eliminará el siguiente registro. Esta seguro de eliminar?';
      let details = "<span class=\"font-weight-bold\" style=\"color:#ff4081 !important;\">&bull;&nbsp;&nbsp;Intervalo de Conversión:</span> [" + this.conversionConfig.description + "]";
      details = details + "<br/><br/><span class=\"font-weight-bold\" style=\"color:#ff4081\">&bull;&nbsp;&nbsp;Número de Créditos:</span> De [" + this.conversionConfig.noCreditsFrom + "] a [" + this.conversionConfig.noCreditsTo + "]";
      details = details + "<br/><br/><span class=\"font-weight-bold\" style=\"color:#ff4081\">&bull;&nbsp;&nbsp;Activo:</span> " + (this.conversionConfig.activeId ? 'Sí' : 'No');
      this.details = details;
      this.viewStatus = 2;
    }
    if(this.mode==="toggleActive"){
      this.toggleActive();
      let newStatus = this.conversionConfig.activeId ? 'activará' : 'desactivará';
      this.confirmTitle = '<i class="icon-attention"></i>&nbsp;&nbsp;Se ' + newStatus + ' el siguiente registro. Esta seguro de ' + newStatus.substring(0,newStatus.length-1) + '?';
      let details = "<span class=\"font-weight-bold\" style=\"color:#ff4081 !important;\">&bull;&nbsp;&nbsp;Intervalo de Conversión:</span> [" + this.conversionConfig.description + "]";
      details = details + "<br/><br/><span class=\"font-weight-bold\" style=\"color:#ff4081\">&bull;&nbsp;&nbsp;Número de Créditos:</span> De [" + this.conversionConfig.noCreditsFrom + "] a [" + this.conversionConfig.noCreditsTo + "]";
      this.details = details;
      this.viewStatus = 2;
    }
  }

  //
  isValid=()=> {
    this.valid=true;
    let errors=[];
    
    if(this.conversionIntervalsError()) errors.push('&bull; Seleccione un intervalo de conversion!');
    if(this.noCreditsFromError()) errors.push('&bull; Ingrese el número de creditos inicial!');
    if(this.noCreditsToError()) errors.push('&bull; Ingrese el número de creditos final!');
    if(this.noCreditsFromToError()) errors.push('&bull; El número de creditos inicial no puede ser mayor al número de creditos final!');

    if(errors.length>0) {
      this.valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }

    if(this.valid){
      let details = "<span class=\"font-weight-bold\" style=\"color:#ff4081 !important;\">&bull;&nbsp;&nbsp;Intervalo de Conversión:</span> [" + this.conversionConfig.description + "]";
      details = details + "<br/><br/><span class=\"font-weight-bold\" style=\"color:#ff4081\">&bull;&nbsp;&nbsp;Número de Créditos:</span> De [" + this.conversionConfig.noCreditsFrom + "] a [" + this.conversionConfig.noCreditsTo + "]";
      details = details + "<br/><br/><span class=\"font-weight-bold\" style=\"color:#ff4081\">&bull;&nbsp;&nbsp;Activo:</span> " + (this.conversionConfig.activeId ? 'Sí' : 'No');
      this.details = details;
      this.viewStatus = 2;
    }else{
      this.viewStatus = 1;
    }
  }

  save=()=> {
    if(this.mode==="delete"){
      this.conversionConfigurationService.delete(this.conversionConfig)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.modalService.dismissAll('success');
          this.toastr.success('El registro se ha eliminado correctamente!');
        }
      });
    }
    if(this.mode==="toggleActive"){
      delete this.conversionConfig.createUserId;
      this.conversionConfig.modifUserId=Number(localStorage.getItem('com_token'));
      let status = 'activado';
      if(!this.conversionConfig.activeId) status = 'desactivado';
      this.conversionConfigurationService.saveUpdate(this.conversionConfig)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.modalService.dismissAll('success');
          this.toastr.success('El registro se ha ' + status + ' correctamente!');
        }
      });
    }
    if(this.mode==="create" || this.mode === "edit"){
      if(this.valid && this.details != null) {
        this.viewStatus=0;
        if(this.mode === "edit"){
          delete this.conversionConfig.createUserId;
          this.conversionConfig.modifUserId=Number(localStorage.getItem('com_token'));
        }
        this.conversionConfigurationService.saveUpdate(this.conversionConfig)
          .pipe(
            tap((resp:any)=> {
              console.log(resp);
              this.modalService.dismissAll('success');
              this.toastr.success('El registro se ha guardado correctamente!');
            }),
            catchError(error=> {
              console.log(error);
              this.modalService.dismissAll('failure');
              return of(this.toastr.error('Ocurrió un error al intentar guardar el registro...'));
            })
          )
          .subscribe();
      }
    }
  }

  closeConfirm=()=> {
    if(this.mode==="delete" || this.mode==="toggleActive"){
      this.modalService.dismissAll();
    }else{
      this.viewStatus = 1;
      console.log(">>> this.selectedConversionIntervals= ",this.selectedConversionIntervals);
      console.log(">>> this.selectedConversionIntervalsDD= ",this.selectedConversionIntervalsDD);
    }
  }
  
  close=()=> {
    this.modalService.dismissAll();
  }


  // HELPERS
  selectedConversionIntervalsError=()=> !(this.selectedConversionIntervals != null && this.selectedConversionIntervals.length > 0);
  conversionIntervalsError=()=> !(this.conversionConfig.intervalId != null && this.conversionConfig.intervalId > 0);
  noCreditsFromError=()=> this.conversionConfig.noCreditsFrom!==0 && !this.conversionConfig.noCreditsFrom;
  noCreditsToError=()=> this.conversionConfig.noCreditsTo!==0 && !this.conversionConfig.noCreditsTo;
  noCreditsFromToError=()=> this.conversionConfig.noCreditsTo != null && this.conversionConfig.noCreditsFrom > this.conversionConfig.noCreditsTo;
  updateNoCreditsFrom=e=> this.conversionConfig.noCreditsFrom=!e || e.trim()===''?null:Number(e);
  updateNoCreditsTo=e=> this.conversionConfig.noCreditsTo=!e || e.trim()===''?null:Number(e);
  toggleActive=()=> this.conversionConfig.activeId=!this.conversionConfig.activeId;

  // EVENTS
  conversionIntervalChange=e=> {
    console.log(">>  conversionIntervalChange > value= ",  e.target.value);
    console.log(">>  conversionIntervalChange > text= ",  e.target.options[e.target.options.selectedIndex].text);
    this.conversionConfig.description = e.target.options[e.target.options.selectedIndex].text;

    console.log(">>  this.conversionConfig.intervalId= ",  this.conversionConfig.intervalId);

    // if(e.length > 0){
    //   this.selectedConversionIntervals=e; 
    //   this.conversionConfig.intervalId = this.selectedConversionIntervals[0].id;
    //   this.conversionConfig.description = this.selectedConversionIntervals[0].description;
    //   console.log(">> this.selectedConversionIntervals= ", this.selectedConversionIntervals);
    // } else {
    //   this.selectedConversionIntervals=[];
    // }
  };

  // INFO
  getCatalogs=(conversionId:number)=> {
    this.viewStatus=0;
    forkJoin(
      this.conversionConfigurationService.getListIntervals()
    )
    .pipe(
      tap(([conversionIntervalsResp]:[any])=> {
        if(conversionIntervalsResp) {
          
          let listOptions = this.listConversionConfig.map(c=>c.intervalId);
          listOptions.forEach( (o, index) => {
            if(o === this.conversionConfig.intervalId) listOptions.splice(index,1);
          });

          this.conversionIntervalsCatalog=conversionIntervalsResp.data.filter(
            function(e) {
              return this.indexOf(e.id) < 0; //No está en listOptions
            }, listOptions
          );

          // let intervalId:any = this.conversionConfig.intervalId;
          // console.log(">>> intervalId= ", intervalId);
          // if(intervalId != null && intervalId>0) {
          //   this.selectedConversionIntervals.push(this.conversionIntervalsCatalog.filter(e=> e.id===intervalId));
          //   this.selectedConversionIntervalsDD.push(intervalId);
          // }
          // console.log(">>> this.selectedConversionIntervals= ",this.selectedConversionIntervals);
          // console.log(">>> this.selectedConversionIntervalsDD= ",this.selectedConversionIntervalsDD);

          this.viewStatus=1;
          // if(this.mode==="edit" || this.mode==="detail"){
          //   this.getSelectedCatalogs(conversionId);
          // }else{
          //   this.viewStatus=1;
          // }
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      })
    )
    .subscribe();
  }

  // getSelectedCatalogs=(conversionId:number)=> {
  //   forkJoin(
  //     this.conversionConfigurationService.getListEmployeeJobs(conversionId),
  //   )
  //   .pipe( 
  //     tap(([employeeJobsResp]:[any])=> { 
  //       if(employeeJobsResp) {
  //         //Cargar PUESTOS SELECCIONADOS
  //         this.selectedEmployeeJobs=employeeJobsResp.data;
  //         this.selectedEmployeeJobsDD=employeeJobsResp.data.map(function(row){
  //           return parseInt(row.id);
  //         });
  //         this.viewStatus=1;
  //       }
  //       else throwError;
  //     }),
  //     catchError(error=> {
  //       console.log(error);
  //       this.viewStatus=-1;
  //       return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
  //     })
  //   )
  //   .subscribe();
  // }


}
